import * as React from "react";

import { CraDto } from "core/backend/data";
import TDatetime from "components/TDatetime";

interface OwnProps {
    dto: CraDto;
    left: number;
}

const Row = ({ dto, left }: OwnProps) =>
    <tr>
        <TDatetime rowSpan={1} date={new Date(dto.dateTimeUtc)} left={left} />
        {(dto.reason ?? "") != ""
            ? <td colSpan={32} style={{ textAlign: "left" }}>{dto.reason}</td>
            : <>
                <td>{dto.cnecTso}</td>
                <td>{dto.cnecName}</td>
                {
                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                        .map(i => <React.Fragment key={i}>
                            <td className="lineLeft">{eval("dto.cra" + i + "Name")}</td>
                            <td>{eval("dto.cra" + i + "Baseline")}</td>
                            <td>{eval("dto.cra" + i + "AfterNrao")}</td>
                        </React.Fragment>)
                }
            </>
        }
    </tr>;

export default Row;